import React from 'react';
import { colors } from 'design-system';
import { Grid, Typography, Divider, makeStyles } from '@material-ui/core';

const useStyle = makeStyles(() => ({
  textGray: {
    color: colors.abbey,
    fontSize: 14,
  },
  rowContainer: {
    marginTop: 22,
    marginBottom: 10,
  },
}));

type Props = {
  description: string;
  value: string;
  hideDivider?: boolean;
};

const InformationRow = ({
  description,
  value,
  hideDivider,
}: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <Grid item className={classes.rowContainer} data-testid="information-row">
      <Grid container justifyContent="space-between" alignItems="baseline">
        <Typography
          variant="caption"
          className={classes.textGray}
          data-testid="description-text"
        >
          {description}
        </Typography>
        <Typography variant="body2" data-testid="value-text">
          {value}
        </Typography>
      </Grid>
      {!hideDivider && <Divider data-testid="row-divider-element" />}
    </Grid>
  );
};

export default InformationRow;
